export const EMPLOYEE_STATUS_META = {
  0: { value: "NOT_ACTIVE", label: "Not Active", color: "ds-pill--danger" },
  1: { value: "ACTIVE", label: "Active", color: "ds-pill--success" },
  2: { value: "BANNED", label: "Banned", color: "ds-pill--warning" },
  3: { value: "BLOCKED", label: "Blocked", color: "ds-pill--warning" },
  5: { value: "DELETED", label: "Deleted", color: "ds-pill--danger" },
  NOT_ACTIVE: { value: "NOT_ACTIVE", label: "Not Active", color: "ds-pill--danger" },
  ACTIVE: { value: "ACTIVE", label: "Active", color: "ds-pill--success" },
  BANNED: { value: "BANNED", label: "Banned", color: "ds-pill--warning" },
  BLOCKED: { value: "BLOCKED", label: "Blocked", color: "ds-pill--warning" },
  DELETED: { value: "DELETED", label: "Deleted", color: "ds-pill--danger" },
};

export const EMPLOYEE_STATUS_OPTIONS = [
  { value: 1, text: "Active" },
  { value: 0, text: "Not Active" },
  { value: 2, text: "Banned" },
  { value: 3, text: "Blocked" },
  { value: 5, text: "Deleted" },
];

export const EMPLOYEE_STATUS_FILTER_OPTIONS = EMPLOYEE_STATUS_OPTIONS.filter((item) => item.value !== 5);

export const getEmployeeStatusMeta = (status) => {
  const normalizedStatus = String(status ?? "").toUpperCase();

  return (
    EMPLOYEE_STATUS_META[status] ||
    EMPLOYEE_STATUS_META[normalizedStatus] || {
      value: normalizedStatus || "UNKNOWN",
      label: "Unknown",
      color: "ds-pill--gray",
    }
  );
};
